module.exports = __webpack_public_path__ + "static/media/resources-icon.bff022d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/resources-icon.svg
// module id = 549
// module chunks = 0